import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationDailyCounters, getBillListData } from '@/api/bairun/financialCenter';
import { mapGetters } from 'vuex';
import NP from 'number-precision';
import moment from 'moment';
import dateUtils from '@/utils/dateUtil';
import stationUtils from '@/utils/station';
export default {
  name: 'FinancialDiff',
  data: function data() {
    var _this = this;

    return {
      data: {},
      billStart: 0,
      billEnd: 0,
      slotT: 50,
      slotMapping: stationUtils.getOrderGoodsTitleMaps(),
      datePickerValue: [(dateUtils.todayTimestamp() - 7 * 24 * 60 * 60) * 1000, (dateUtils.todayTimestamp() - 24 * 60 * 60) * 1000],
      sheetUnLoadCount: 1,
      downloadLoading: false,
      downloadBillLoading: false,
      stationDailyDiffData: [],
      stationMonthTotalData: [],
      excelSheets: [{
        tableId: 'stationDailyDiffData',
        name: '日报表差异',
        tableRows: 4
      }, {
        tableId: 'stationMonthTotalData',
        name: '本月实收统计',
        tableRows: 2
      }],
      selectedStation: {
        'ID': 0,
        'stationName': '',
        'statTag': '选择站点',
        'statAbbr': '',
        'appId': 'aaa'
      },
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return _this.userInfo.authorityId === '888' ? false : pTime.getTime() < new Date() - 92 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  watch: {
    datePickerValue: function datePickerValue() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['stationDailyDiffData'].doLayout();

        _this2.$refs['stationMonthTotalData'].doLayout(); // console.log('refsUpdate')

      }); // this.loadData()
    }
  },
  created: function created() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.$refs['stationDailyDiffData'].doLayout();

      _this3.$refs['stationMonthTotalData'].doLayout(); // console.log('refsUpdate')

    });
  },
  updated: function updated() {
    var _this4 = this;

    this.$nextTick(function () {
      _this4.$refs['stationDailyDiffData'].doLayout();

      _this4.$refs['stationMonthTotalData'].doLayout(); // console.log('refsUpdate')

    });
  },
  methods: {
    showMonthAuthCode: function showMonthAuthCode() {
      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择对应的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      } // todo 后续考虑由统一后台生成


      this.$alert('查询到 <span style="color: orangered">' + this.selectedStation.statTag + '</span> 当前的授权码为：' + parseInt(parseInt(this.selectedStation.ID) - 9000 + '' + moment().format('YYMM')).toString(8), '站点授权码', {
        dangerouslyUseHTMLString: true
      });
    },
    numberFix: function numberFix(number, len) {
      return dateUtils.numberFix(number, len);
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = arguments[i] !== undefined ? NP.plus(res, arguments[i]) : res;
      }

      return res;
    },
    npMinus: function npMinus() {
      var res = arguments[0];

      for (var i in arguments) {
        res = arguments[i] !== undefined && i > 0 ? NP.minus(res, arguments[i]) : res;
      }

      return res;
    },
    amountFormat: function amountFormat(value) {
      return NP.round(value, 2);
    },
    npPlusArr: function npPlusArr(arr) {
      var res = 0;

      for (var i in arr) {
        // // console.log('arr', i, arr.length, arr[i], Number(arr[i]))
        res = NP.plus(res, Number(arr[i]));
      }

      return res;
    },
    getSummaries: function getSummaries(param) {
      var _this5 = this;

      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        var values;

        if (column.property === 'dailyCashDeposit.depositValue') {
          values = data.map(function (item) {
            return Number(item['dailyCashDeposit']['depositValue']);
          });
        } else if (column.property === 'dailyCashDeposit.depositLeftValue') {
          values = data.map(function (item) {
            return Number(item['dailyCashDeposit']['depositLeftValue']);
          });
        } else if (column.property === 'selfDiscount') {
          values = data.map(function (item) {
            return item['xwlCapitalDiscount'] ? NP.minus(Number(item['selfDiscount']), Number(item['xwlCapitalDiscount'])) : Number(item['selfDiscount']);
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = _this5.numberFix(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    },
    getSummaries2: function getSummaries2(param) {
      var _this6 = this;

      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '实收金额';
          return;
        }

        var values = data.map(function (item) {
          return item['code'] === 'item_total' && column.property.indexOf('discount') === 0 ? -Number(item[column.property]) : item['code'] === 'item_return' && column.property.indexOf('discount') === 0 ? Number(item[column.property]) : item['code'] === 'item_original' ? Number(item[column.property]) : 0;
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = _this6.numberFix(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    },
    loadData: function loadData() {
      var _this7 = this;

      if (this.downloadLoading) {
        return;
      }

      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择对应的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.billStart = 0;
      this.billEnd = 0;
      this.downloadLoading = true;
      getStationDailyCounters({
        appId: this.selectedStation.appId,
        sellerId: this.selectedStation.ID,
        startDate: moment(this.datePickerValue[0]).format('YYYYMMDD'),
        endDate: moment(this.datePickerValue[1]).format('YYYYMMDD')
      }).then(function (response) {
        // // console.log('getStationDailyDiff', response)
        _this7.stationDailyDiffData = response.data;
        var totalItem = {
          'item_return': {
            title: '回罐',
            code: 'item_return',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2002': {
            title: '货车帮',
            code: 'item_2002',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2001': {
            title: '滴滴',
            code: 'item_2001',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2004': {
            title: '团油',
            code: 'item_2004',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2013': {
            title: '团油车队',
            code: 'item_2013',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2014': {
            title: '鲸车惠',
            code: 'item_2014',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2011': {
            title: '佰思达',
            code: 'item_2011',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_1008': {
            title: '支付宝',
            code: 'item_1008',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2007': {
            title: '嗨卡',
            code: 'item_2007',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2012': {
            title: '爱车',
            code: 'item_2012',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2009': {
            title: '途虎',
            code: 'item_2009',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_2003': {
            title: '易加油',
            code: 'item_2003',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_user': {
            title: '会员优惠',
            code: 'item_user',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_station': {
            title: '直降优惠',
            code: 'item_station',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_xwl': {
            title: '中深出资',
            code: 'item_xwl',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_svc': {
            title: '卡优惠',
            code: 'item_svc',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_total': {
            title: '合计',
            code: 'item_total',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          },
          'item_original': {
            title: '政府价应收',
            code: 'item_original',
            nums0: 0,
            discount0: 0,
            nums92: 0,
            discount92: 0,
            nums95: 0,
            discount95: 0,
            nums: 0,
            discount: 0
          }
        };
        _this7.downloadLoading = false;

        if (_this7.stationDailyDiffData.length > 0) {
          _this7.billStart = moment(_this7.stationDailyDiffData[0]['startDate']).unix();
          _this7.billEnd = moment(_this7.stationDailyDiffData[_this7.stationDailyDiffData.length - 1]['endDate']).unix();
          var _that = _this7;
          _this7.sheetUnLoadCount = 0;

          _this7.stationDailyDiffData.forEach(function (row) {
            var elRow = row;
            elRow.diesel0Nums = 0;
            elRow.diesel0Amount = 0;
            elRow.petrol92Nums = 0;
            elRow.petrol92Amount = 0;
            elRow.petrol95Nums = 0;
            elRow.petrol95Amount = 0;
            elRow.oilNums = 0;
            elRow.oilAmount = 0; // 油品回罐升数

            elRow.oilReturnNums = 0;
            elRow.oilReturnAmount = 0; // 油品自用升数

            elRow.oilWarnNums = 0;
            elRow.oilWarnAmount = 0; // 油品异常升数

            elRow.oilWarnNums = 0;
            elRow.oilWarnAmount = 0; // 油品销量升数

            elRow.oilSaleNums = 0;
            elRow.oilSaleAmount = 0; // 优惠

            elRow.selfDiscount = 0;
            elRow.tradeDiscount = 0;
            elRow.platDiscount = 0;
            elRow.cashAmount = 0; // 现金

            elRow.svcAmount = 0; // 卡消费

            elRow.walletAmount = 0; // 电子钱包

            elRow.creditAmount = 0; // 授权卡

            elRow.accountAmount = 0; // 记账卡

            elRow.onlineAmount = 0; // 通联在线支付

            elRow.onlineHuAmount = 0; // 通联在线支付（户）

            elRow.onlineGeAmount = 0; // 通联在线支付（个）

            elRow.posAmount = 0; // 通联POS机

            elRow.lklOnlineAmount = 0; // 拉卡拉在线支付

            elRow.lklOnlineHuAmount = 0; // 拉卡拉在线支付（户）

            elRow.lklOnlineGeAmount = 0; // 拉卡拉在线支付（个）

            elRow.lklPosAmount = 0; // 拉卡拉POS机

            elRow.fyOnlineAmount = 0; // 富友在线支付

            elRow.fyOnlineHuAmount = 0; // 富友在线支付（户）

            elRow.fyOnlineGeAmount = 0; // 富友在线支付（个）

            elRow.fyPosAmount = 0; // 富友POS机

            elRow.xyPosAmount = 0; // 星驿POS机

            elRow.transferAmount = 0; // 转账

            elRow.otherAmount = 0; // 其他 挂账等

            elRow.plat1008Amount = 0; // 刷脸付

            elRow.plat2001Amount = 0; // 滴滴

            elRow.plat2002Amount = 0; // 货车帮

            elRow.plat2003Amount = 0; // 易加油

            elRow.plat2004Amount = 0; // 团油

            elRow.plat2005Amount = 0; // 小象

            elRow.plat2007Amount = 0; // 嗨卡

            elRow.plat2008Amount = 0; // 喂车车

            elRow.plat2009Amount = 0; // 途虎

            elRow.plat2010Amount = 0; // 货拉拉

            elRow.plat2011Amount = 0; // 百思达

            elRow.plat2012Amount = 0; // 爱车平台

            elRow.plat2013Amount = 0; // 团油车队

            elRow.plat2014Amount = 0; // 鲸车惠

            elRow.lossCardAmount = 0; // 挂失补办

            elRow.shopAmount = 0; // 便利店

            elRow.loadometerAmount = 0; // 地磅计费

            elRow.walletChargeAmount = 0; // 钱包充值

            elRow.chargeAmount = 0; // 卡充值

            elRow.chargeBackAmount = 0; // 退卡/回款

            elRow.walletChargeAmount = 0; // 钱包充值

            elRow.xwlCapitalDiscount = 0; // 新文旅出资

            elRow.totalReceivableAmount = 0; // 合计

            elRow.totalDiff = 0; // 差异

            if (row.dailyPayWayData.length > 0) {
              row.dailyPayWayData.forEach(function (el, index) {
                if (el.payWay === 1001) {
                  // 现金
                  var tempDailyCheckPaymentsAmount = el.checkPaymentsAmount.split('|');
                  tempDailyCheckPaymentsAmount.push(0);
                  tempDailyCheckPaymentsAmount.push(0);
                  tempDailyCheckPaymentsAmount.push(0);
                  elRow.cashAmountArr = tempDailyCheckPaymentsAmount.slice(0, 3);
                  elRow.cashAmount = elRow.cashAmountArr && elRow.cashAmountArr.length > 0 ? _that.npPlusArr(elRow.cashAmountArr) : 0;
                } else if (el.payWay === 1002) {
                  // 卡消费
                  elRow.svcAmount = el.stationAmount;
                } else if (el.payWay === 1010) {
                  // 电子钱包
                  elRow.walletAmount = NP.minus(el.receivablesAmount, el.tradeDiscount);
                } else if (el.payWay === 7002) {
                  // 授权卡
                  elRow.creditAmount = el.stationAmount;
                } else if (el.payWay === 7005) {
                  // 记账卡
                  elRow.accountAmount = el.stationAmount;
                } else if (el.payWay === 1003 || el.payWay === 1004) {
                  // 通联在线支付
                  elRow.onlineAmount = elRow.onlineAmount !== undefined ? NP.plus(elRow.onlineAmount, el.receivablesAmount) : el.receivablesAmount;

                  if (el.receivablesRatio !== undefined) {
                    elRow.onlineHuAmount = NP.times(elRow.onlineAmount, el.receivablesRatio / 100);
                    elRow.onlineGeAmount = NP.minus(elRow.onlineAmount, elRow.onlineHuAmount);
                  }
                } else if (el.payWay === 1013 || el.payWay === 1014) {
                  // 拉卡拉在线支付
                  elRow.lklOnlineAmount = elRow.lklOnlineAmount !== undefined ? NP.plus(elRow.lklOnlineAmount, el.receivablesAmount) : el.receivablesAmount;

                  if (el.receivablesRatio !== undefined) {
                    elRow.lklOnlineHuAmount = NP.times(elRow.lklOnlineAmount, el.receivablesRatio / 100);
                    elRow.lklOnlineGeAmount = NP.minus(elRow.lklOnlineAmount, elRow.lklOnlineHuAmount);
                  }
                } else if (el.payWay === 1023 || el.payWay === 1024) {
                  // 富友在线支付
                  elRow.fyOnlineAmount = elRow.fyOnlineAmount !== undefined ? NP.plus(elRow.fyOnlineAmount, el.receivablesAmount) : el.receivablesAmount;

                  if (el.receivablesRatio !== undefined) {
                    elRow.fyOnlineHuAmount = NP.times(elRow.fyOnlineAmount, el.receivablesRatio / 100);
                    elRow.fyOnlineGeAmount = NP.minus(elRow.fyOnlineAmount, elRow.fyOnlineHuAmount);
                  }
                } else if (el.payWay === 1005) {
                  // 通联POS机
                  elRow.posAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1015) {
                  // 拉卡拉POS机
                  elRow.lklPosAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1025) {
                  // 富友POS机
                  elRow.fyPosAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1045) {
                  // 星驿POS机
                  elRow.xyPosAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1006) {
                  // 转账
                  elRow.transferAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1009) {
                  // 其他 挂账等
                  elRow.otherAmount = elRow.otherAmount !== undefined ? NP.plus(elRow.otherAmount, el.checkPaymentsAmount) : el.checkPaymentsAmount;
                } else if (el.payWay === 1008) {
                  // 刷脸付
                  elRow.plat1008Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2001) {
                  // 滴滴
                  elRow.plat2001Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2002) {
                  // 货车帮
                  elRow.plat2002Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2003) {
                  // 易加油
                  elRow.plat2003Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2004) {
                  // 团油
                  elRow.plat2004Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2005) {
                  // 小象
                  elRow.plat2005Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2007) {
                  // 嗨卡
                  elRow.plat2007Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2008) {
                  // 喂车车
                  elRow.plat2008Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2009) {
                  // 途虎
                  elRow.plat2009Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2010) {
                  // 货拉拉
                  elRow.plat2010Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2011) {
                  // 佰思达
                  elRow.plat2011Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2012) {
                  // 爱车平台
                  elRow.plat2012Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2013) {
                  // 团油车队
                  elRow.plat2013Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2014) {
                  // 鲸车惠
                  elRow.plat2014Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 7001) {
                  // 挂失补办
                  elRow.lossCardAmount = el.receivablesAmount;
                }

                elRow.shopAmount = elRow.shopAmount !== undefined ? NP.plus(elRow.shopAmount, el.shopPaymentsAmount) : el.shopPaymentsAmount;
                elRow.loadometerAmount = elRow.loadometerAmount !== undefined ? NP.plus(elRow.loadometerAmount, el.loadometerAmount) : el.loadometerAmount;
              });
              elRow.svcAmount = elRow.svcAmount !== undefined ? elRow.creditAmount !== undefined ? NP.minus(elRow.svcAmount, elRow.creditAmount) : elRow.svcAmount : 0;
              elRow.svcAmount = elRow.svcAmount !== undefined ? elRow.accountAmount !== undefined ? NP.minus(elRow.svcAmount, elRow.accountAmount) : elRow.svcAmount : 0;
            }

            if (row.dailyGoodsData.length > 0) {
              row.dailyGoodsData.forEach(function (el) {
                if (el.sellerOrderType === 4) {
                  // 充值数据
                  if (el.goodsSpu === 'spu1000000004') {
                    // 钱包充值
                    elRow.walletChargeAmount = elRow.walletChargeAmount !== undefined ? NP.plus(elRow.walletChargeAmount, el.receivablesAmount) : el.receivablesAmount;
                  } else if (el.goodsSpu === 'loss1000000001') {
                    return;
                  } else {
                    elRow.chargeAmount = elRow.chargeAmount !== undefined ? NP.plus(elRow.chargeAmount, el.receivablesAmount) : el.receivablesAmount;
                  }

                  if (el.receivablesAmount < 0) {
                    elRow.chargeBackAmount = elRow.chargeBackAmount !== undefined ? NP.plus(elRow.chargeBackAmount, el.receivablesAmount) : el.receivablesAmount;
                  }

                  return;
                }

                if (el.goodsSpu === '0') {
                  // 柴油
                  elRow.diesel0Nums = el.goodsNums;
                  elRow.diesel0Amount = el.payablesAmount;
                  totalItem['item_original']['nums0'] = NP.plus(totalItem['item_original']['nums0'], el.goodsNums);
                  totalItem['item_original']['discount0'] = NP.plus(totalItem['item_original']['discount0'], el.payablesAmount);
                  totalItem['item_return']['nums0'] = NP.plus(totalItem['item_return']['nums0'], el.returnGoodsNums);
                  totalItem['item_return']['discount0'] = NP.plus(totalItem['item_return']['discount0'], el.returnPayablesAmount);
                  totalItem['item_user']['nums0'] = NP.plus(totalItem['item_user']['nums0'], el.sumUserNums);
                  totalItem['item_user']['discount0'] = NP.plus(totalItem['item_user']['discount0'], el.sumUserDiscount);
                  totalItem['item_svc']['nums0'] = NP.plus(totalItem['item_svc']['nums0'], el.sumSvcNums);
                  totalItem['item_svc']['discount0'] = NP.plus(totalItem['item_svc']['discount0'], el.sumSvcDiscount);
                  totalItem['item_station']['nums0'] = NP.plus(totalItem['item_station']['nums0'], el.goodsOriginal > el.goodsPrice ? el.goodsNums : 0);
                  totalItem['item_station']['discount0'] = NP.plus(totalItem['item_station']['discount0'], el.goodsOriginal > el.goodsPrice ? NP.times(el.goodsNums, NP.minus(el.goodsOriginal, el.goodsPrice)) : 0); // if (el.goodsOriginal > el.goodsPrice) {
                  //   console.log('0# item_station', el.dailyDate, el.goodsNums)
                  // }
                } else if (el.goodsSpu === '92') {
                  // 汽油 92
                  elRow.petrol92Nums = el.goodsNums;
                  elRow.petrol92Amount = el.payablesAmount;
                  totalItem['item_original']['nums92'] = NP.plus(totalItem['item_original']['nums92'], el.goodsNums);
                  totalItem['item_original']['discount92'] = NP.plus(totalItem['item_original']['discount92'], el.payablesAmount);
                  totalItem['item_return']['nums92'] = NP.plus(totalItem['item_return']['nums92'], el.returnGoodsNums);
                  totalItem['item_return']['discount92'] = NP.plus(totalItem['item_return']['discount92'], el.returnPayablesAmount);
                  totalItem['item_user']['nums92'] = NP.plus(totalItem['item_user']['nums92'], el.sumUserNums);
                  totalItem['item_user']['discount92'] = NP.plus(totalItem['item_user']['discount92'], el.sumUserDiscount);
                  totalItem['item_svc']['nums92'] = NP.plus(totalItem['item_svc']['nums92'], el.sumSvcNums);
                  totalItem['item_svc']['discount92'] = NP.plus(totalItem['item_svc']['discount92'], el.sumSvcDiscount);
                  totalItem['item_station']['nums92'] = NP.plus(totalItem['item_station']['nums92'], el.goodsOriginal > el.goodsPrice ? el.goodsNums : 0);
                  totalItem['item_station']['discount92'] = NP.plus(totalItem['item_station']['discount92'], el.goodsOriginal > el.goodsPrice ? NP.times(el.goodsNums, NP.minus(el.goodsOriginal, el.goodsPrice)) : 0); // if (el.goodsOriginal > el.goodsPrice) {
                  //   console.log('92# item_station', el.dailyDate, el.goodsNums)
                  // }
                } else if (el.goodsSpu === '95') {
                  // 汽油 95
                  elRow.petrol95Nums = el.goodsNums;
                  elRow.petrol95Amount = el.payablesAmount;
                  totalItem['item_original']['nums95'] = NP.plus(totalItem['item_original']['nums95'], el.goodsNums);
                  totalItem['item_original']['discount95'] = NP.plus(totalItem['item_original']['discount95'], el.payablesAmount);
                  totalItem['item_return']['nums95'] = NP.plus(totalItem['item_return']['nums95'], el.returnGoodsNums);
                  totalItem['item_return']['discount95'] = NP.plus(totalItem['item_return']['discount95'], el.returnPayablesAmount);
                  totalItem['item_user']['nums95'] = NP.plus(totalItem['item_user']['nums95'], el.sumUserNums);
                  totalItem['item_user']['discount95'] = NP.plus(totalItem['item_user']['discount95'], el.sumUserDiscount);
                  totalItem['item_svc']['nums95'] = NP.plus(totalItem['item_svc']['nums95'], el.sumSvcNums);
                  totalItem['item_svc']['discount95'] = NP.plus(totalItem['item_svc']['discount95'], el.sumSvcDiscount);
                  totalItem['item_station']['nums95'] = NP.plus(totalItem['item_station']['nums95'], el.goodsOriginal > el.goodsPrice ? el.goodsNums : 0);
                  totalItem['item_station']['discount95'] = NP.plus(totalItem['item_station']['discount95'], el.goodsOriginal > el.goodsPrice ? NP.times(el.goodsNums, NP.minus(el.goodsOriginal, el.goodsPrice)) : 0); // if (el.goodsOriginal > el.goodsPrice) {
                  //   console.log('95# item_station', el.dailyDate, el.goodsNums)
                  // }
                }

                if (el.sellerOrderType === 1) {
                  totalItem['item_original']['nums'] = NP.plus(totalItem['item_original']['nums0'], totalItem['item_original']['nums92'], totalItem['item_original']['nums95']);
                  totalItem['item_original']['discount'] = NP.plus(totalItem['item_original']['discount0'], totalItem['item_original']['discount92'], totalItem['item_original']['discount95']);
                  totalItem['item_return']['nums'] = NP.plus(totalItem['item_return']['nums0'], totalItem['item_return']['nums92'], totalItem['item_return']['nums95']);
                  totalItem['item_return']['discount'] = NP.plus(totalItem['item_return']['discount0'], totalItem['item_return']['discount92'], totalItem['item_return']['discount95']);
                  totalItem['item_user']['nums'] = NP.plus(totalItem['item_user']['nums0'], totalItem['item_user']['nums92'], totalItem['item_user']['nums95']);
                  totalItem['item_user']['discount'] = NP.plus(totalItem['item_user']['discount0'], totalItem['item_user']['discount92'], totalItem['item_user']['discount95']);
                  totalItem['item_svc']['nums'] = NP.plus(totalItem['item_svc']['nums0'], totalItem['item_svc']['nums92'], totalItem['item_svc']['nums95']);
                  totalItem['item_svc']['discount'] = NP.plus(totalItem['item_svc']['discount0'], totalItem['item_svc']['discount92'], totalItem['item_svc']['discount95']);
                  totalItem['item_station']['nums'] = NP.plus(totalItem['item_station']['nums0'], totalItem['item_station']['nums92'], totalItem['item_station']['nums95']);
                  totalItem['item_station']['discount'] = NP.plus(totalItem['item_station']['discount0'], totalItem['item_station']['discount92'], totalItem['item_station']['discount95']);
                } // 油品油机升数


                elRow.oilNums = elRow.oilNums !== undefined ? NP.plus(elRow.oilNums, el.goodsNums) : el.goodsNums;
                elRow.oilAmount = elRow.oilAmount !== undefined ? NP.plus(elRow.oilAmount, el.payablesAmount) : el.payablesAmount; // 油品回罐升数

                elRow.oilReturnNums = elRow.oilReturnNums !== undefined ? NP.plus(elRow.oilReturnNums, el.returnGoodsNums) : el.returnGoodsNums;
                elRow.oilReturnAmount = elRow.oilReturnAmount !== undefined ? NP.plus(elRow.oilReturnAmount, el.returnPayablesAmount) : el.returnPayablesAmount; // 油品自用升数

                elRow.oilWarnNums = elRow.oilWarnNums !== undefined ? NP.plus(elRow.oilWarnNums, el.selfGoodsNums) : el.selfGoodsNums;
                elRow.oilWarnAmount = elRow.oilWarnAmount !== undefined ? NP.plus(elRow.oilWarnAmount, el.selfPayablesAmount) : el.selfPayablesAmount; // 油品异常升数

                elRow.oilWarnNums = elRow.oilWarnNums !== undefined ? NP.plus(elRow.oilWarnNums, el.warnGoodsNums) : el.warnGoodsNums;
                elRow.oilWarnAmount = elRow.oilWarnAmount !== undefined ? NP.plus(elRow.oilWarnAmount, el.warnPayablesAmount) : el.warnPayablesAmount; // 油品销量升数

                elRow.oilSaleNums = NP.minus(elRow.oilNums, elRow.oilReturnNums, elRow.oilWarnNums);
                elRow.oilSaleAmount = NP.minus(elRow.oilAmount, elRow.oilReturnAmount, elRow.oilWarnAmount); // 优惠

                elRow.selfDiscount = elRow.selfDiscount !== undefined ? NP.plus(elRow.selfDiscount, el.discountAmount) : el.discountAmount;
                elRow.tradeDiscount = elRow.tradeDiscount !== undefined ? NP.plus(elRow.tradeDiscount, el.tradeDiscount) : el.tradeDiscount;
              });
            }

            if (row.dailyDiscountCapital.length > 0) {
              row.dailyDiscountCapital.forEach(function (el2) {
                if (el2.capitalCategory === 2) {
                  elRow.xwlCapitalDiscount = elRow.xwlCapitalDiscount !== undefined ? NP.plus(elRow.xwlCapitalDiscount, el2.capitalAmount) : el2.capitalAmount;

                  if (el2.stationId === 10006) {
                    totalItem['item_xwl']['discount95'] = NP.plus(totalItem['item_xwl']['discount95'], -el2.capitalAmount);
                  } else {
                    totalItem['item_xwl']['discount92'] = NP.plus(totalItem['item_xwl']['discount92'], -el2.capitalAmount);
                  }
                }
              });
              totalItem['item_xwl']['discount'] = NP.plus(totalItem['item_xwl']['discount0'], totalItem['item_xwl']['discount92'], totalItem['item_xwl']['discount95']);
            }

            if (row.dailyPlatformData.length > 0) {
              row.dailyPlatformData.forEach(function (el3) {
                var itemIndex = 'item_' + el3['platform'];

                if (!totalItem[itemIndex] || totalItem[itemIndex] === undefined) {
                  return;
                }

                totalItem[itemIndex]['nums0'] = NP.plus(totalItem[itemIndex]['nums0'], el3.nums0);
                totalItem[itemIndex]['discount0'] = NP.plus(totalItem[itemIndex]['discount0'], el3.discount0);
                totalItem[itemIndex]['nums92'] = NP.plus(totalItem[itemIndex]['nums92'], el3.nums92);
                totalItem[itemIndex]['discount92'] = NP.plus(totalItem[itemIndex]['discount92'], el3.discount92);
                totalItem[itemIndex]['nums95'] = NP.plus(totalItem[itemIndex]['nums95'], el3.nums95);
                totalItem[itemIndex]['discount95'] = NP.plus(totalItem[itemIndex]['discount95'], el3.discount95);
                totalItem[itemIndex]['nums'] = NP.plus(totalItem[itemIndex]['nums95'], totalItem[itemIndex]['nums92'], totalItem[itemIndex]['nums0']);
                totalItem[itemIndex]['discount'] = NP.plus(totalItem[itemIndex]['discount95'], totalItem[itemIndex]['discount92'], totalItem[itemIndex]['discount0']);
              });
            }

            elRow.totalReceivableAmount = _that.npPlus(elRow.cashAmount, elRow.transferAmount, elRow.svcAmount, elRow.walletAmount, elRow.creditAmount, elRow.accountAmount, elRow.posAmount, elRow.onlineAmount, elRow.lklPosAmount, elRow.lklOnlineAmount, elRow.fyPosAmount, elRow.xyPosAmount, elRow.fyOnlineAmount, elRow.plat1008Amount, elRow.plat2001Amount, elRow.plat2002Amount, elRow.plat2003Amount, elRow.plat2004Amount, elRow.plat2005Amount, elRow.plat2007Amount, elRow.plat2008Amount, elRow.plat2009Amount, elRow.plat2010Amount, elRow.plat2011Amount, elRow.plat2012Amount, elRow.plat2013Amount, elRow.plat2014Amount, elRow.otherAmount, elRow.oilReturnAmount, elRow.oilWarnAmount);
            elRow.totalDiff = _that.amountFormat(_that.npMinus(elRow.totalReceivableAmount, -elRow.selfDiscount, -elRow.platDiscount, -elRow.tradeDiscount, elRow.oilAmount, elRow.shopAmount, elRow.chargeAmount, elRow.walletChargeAmount, elRow.loadometerAmount, elRow.lossCardAmount), 2);
          });

          for (var i in totalItem) {
            if (i === 'item_original' || i === 'item_total') {
              continue;
            }

            totalItem['item_total']['nums0'] = NP.plus(totalItem['item_total']['nums0'], totalItem[i]['nums0']);
            totalItem['item_total']['nums92'] = NP.plus(totalItem['item_total']['nums92'], totalItem[i]['nums92']);
            totalItem['item_total']['nums95'] = NP.plus(totalItem['item_total']['nums95'], totalItem[i]['nums95']);
            totalItem['item_total']['discount0'] = NP.plus(totalItem['item_total']['discount0'], totalItem[i]['discount0']);
            totalItem['item_total']['discount92'] = NP.plus(totalItem['item_total']['discount92'], totalItem[i]['discount92']);
            totalItem['item_total']['discount95'] = NP.plus(totalItem['item_total']['discount95'], totalItem[i]['discount95']);
          }

          totalItem['item_total']['nums'] = NP.plus(totalItem['item_total']['nums0'], totalItem['item_total']['nums92'], totalItem['item_total']['nums95']);
          totalItem['item_total']['discount'] = NP.plus(totalItem['item_total']['discount0'], totalItem['item_total']['discount92'], totalItem['item_total']['discount95']); // 处理政府价应收需减去回罐 需加上直降优惠

          for (var _i in totalItem['item_original']) {
            if (_i.indexOf('nums') === 0) {
              totalItem['item_original'][_i] = NP.plus(totalItem['item_original'][_i], -totalItem['item_return'][_i]);
            }

            if (_i.indexOf('discount') === 0) {
              totalItem['item_original'][_i] = NP.plus(totalItem['item_original'][_i], -totalItem['item_return'][_i], totalItem['item_station'][_i]);
            }
          }

          _this7.stationMonthTotalData = Object.values(totalItem);
        }
      }).catch(function () {
        _this7.downloadLoading = false;
      });
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this8 = this;

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择对应的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.sheetUnLoadCount > 0) {
        _Message({
          message: '请查询核对过后进行下载',
          type: 'error',
          duration: 5 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, _this8.selectedStation.statTag + moment(_this8.datePickerValue[0]).format('YYYY年MM月DD日') + ' ~ ' + moment(_this8.datePickerValue[1]).format('YYYY年MM月DD日') + excelName);
        _this8.downloadLoading = false;
      }).catch(function () {
        _this8.downloadLoading = false;
      });
    },
    handleDownloadBill: function handleDownloadBill(e) {
      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择对应的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.billStart < 100000 || this.billEnd < 100000) {
        _Message({
          message: '未查询到有效的交班周期',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.downloadBillLoading = true;
      var dataListObj = {
        page: 1,
        per: 500,
        downloadTotal: 0,
        end: 1,
        dataList: []
      };
      this.handleDownloadData(dataListObj, e);
    },
    handleDownloadData: function handleDownloadData(dataListObj, e) {
      var _this9 = this;

      var page = dataListObj.page,
          per = dataListObj.per,
          downloadTotal = dataListObj.downloadTotal,
          end = dataListObj.end,
          dataList = dataListObj.dataList; // console.log(page, per, downloadTotal, end, dataList, new Date())

      if ((page - 1) * per <= downloadTotal) {
        getBillListData(this.slotCounterName, this.selectedStation.ID, this.billStart, this.billEnd, page, per, '', 0, 0, this.beginId, moment(this.datePickerValue[1]).format('YYYYMMDD')).then(function (response) {
          var downloadStats = response.data;
          console.log('response.data', downloadStats);
          var list = downloadStats && downloadStats.list ? downloadStats.list : [];

          if (list.length > 0) {
            list.forEach(function (ele) {
              dataList.push(ele);
            });
            dataListObj.downloadTotal = downloadStats.total || 0;
            dataListObj.end = Math.ceil(downloadStats.total / per) || 1;
            _this9.beginId = downloadStats.BeginId || 0;
          }

          var reg = RegExp(/\~((\d+\.?\d*)|(\d*\.\d+))\%$/);

          if (page >= dataListObj.end) {
            e.target.innerText = e.target.innerText.replace(reg, '');
          } else {
            var percentStr = '~' + Math.floor(page * 100 / dataListObj.end) + '%'; // // console.log(e.target.innerText, reg.test(e.target.innerText), e.target.innerText.replace(reg, percentStr))

            e.target.innerText = reg.test(e.target.innerText) ? e.target.innerText.replace(reg, percentStr) : e.target.innerText + percentStr;
          }

          dataListObj.page++;
          return _this9.handleDownloadData(dataListObj, e);
        });
      } else {
        return this.billExcelExport(dataListObj.dataList);
      }
    },
    billExcelExport: function billExcelExport(dataList) {
      var _this10 = this;

      import('@/utils/Export2Excel').then(function (excel) {
        var filename = '表格';
        var filenameExt = '交易';

        if (_this10.slotT > 10 && _this10.slotT < 100) {
          filename = '日报' + filenameExt + '账单明细';
        } else if (_this10.slotT < 10) {
          filename = '交班' + filenameExt + '账单明细';
        }

        var tHeader = Object.values(_this10.slotMapping);
        var filterVal = Object.keys(_this10.slotMapping);

        var data = _this10.formatJson(filterVal, dataList);

        excel.export_json_to_excel({
          header: tHeader,
          data: data,
          filename: _this10.selectedStation.statTag + '-' + filename + '-' + moment(_this10.datePickerValue[0]).format('YYYYMMDD') + '~' + moment(_this10.datePickerValue[1]).format('YYYYMMDD'),
          autoWidth: true,
          bookType: 'xlsx'
        });
        _this10.downloadBillLoading = false;
      });
    },
    dateNormalFormat: function dateNormalFormat(ts) {
      if (!ts) {
        return '';
      }

      return dateUtils.normalFormat(ts, 'YYYY-MM-DD HH:mm:ss');
    },
    formatJson: function formatJson(filterVal, jsonData) {
      var _this11 = this;

      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          if (j === 'Timestamp') {
            return _this11.timestamp2datestring(v[j]);
          } else if (j === 'payType') {
            return stationUtils.getPtTitle(v[j]);
          } else if (j === 'refundAt' || j === 'payAt' || j === 'CreatedAt') {
            return _this11.dateNormalFormat(v[j]);
          } else if (j === 'orderSource' || j === 'orderType' || j === 'payChannel' || j === 'tradeChannel') {
            return stationUtils.getOSOTPCTitle(v[j]);
          } else if (j === 'isAllRefund') {
            return v[j] ? '是' : '否';
          } else if (j === 'isBrUser') {
            return v[j] ? '是' : '否';
          } else if (j === 'billType') {
            return stationUtils.getBillTypeTitle(v[j]);
          } else if (j === 'stationName') {
            return v['station'][j];
          } else if (j === 'svcCard') {
            return v['tradeChannel'] === 1002 ? v['tradeNo'] : '-';
          } else if (j === 'gift') {
            return v['goodsGift']['goodsGiftDetail'] && v['goodsGift']['goodsGiftDetail'].length > 0 ? v['goodsGift']['goodsGiftDetail'][0]['goodsName'] : '';
          } else if (j === 'giftNum') {
            return v['goodsGift']['goodsGiftDetail'] && v['goodsGift']['goodsGiftDetail'].length > 0 ? v['goodsGift']['goodsGiftDetail'][0]['goodsNum'] : '';
          } else if (j === 'giftCost') {
            return v['goodsGift']['goodsGiftDetail'] && v['goodsGift']['goodsGiftDetail'].length > 0 ? v['goodsGift']['goodsGiftDetail'][0]['goodsCost'] : '';
          } else if (j === 'gift2') {
            return v['goodsGift']['goodsGiftDetail'] && v['goodsGift']['goodsGiftDetail'].length > 1 ? v['goodsGift']['goodsGiftDetail'][1]['goodsName'] : '';
          } else if (j === 'giftNum2') {
            return v['goodsGift']['goodsGiftDetail'] && v['goodsGift']['goodsGiftDetail'].length > 1 ? v['goodsGift']['goodsGiftDetail'][1]['goodsNum'] : '';
          } else if (j === 'giftCost2') {
            return v['goodsGift']['goodsGiftDetail'] && v['goodsGift']['goodsGiftDetail'].length > 1 ? v['goodsGift']['goodsGiftDetail'][1]['goodsCost'] : '';
          } else if (j === 'mobile') {
            return v['uid'] > 10000 ? v['user'][j] : '-';
          } else if (j === 'nickname') {
            return v['uid'] > 10000 ? v['user'][j] : '-';
          } else if (j === 'sellerOrderType') {
            return stationUtils.getSellerOrderTypeTitle(v[j]);
          } else if (j === 'refundAmount') {
            return v['billType'] === 2 ? v['receivablesAmount'] : 0;
          } else if (j === 'receivablesAmount') {
            return v['billType'] === 1 ? v[j] : -v[j];
          } else if (j === 'payablesAmount') {
            return v['billType'] === 1 ? v[j] : -v[j];
          } else if (j === 'goodsNum') {
            return v['billType'] === 1 ? v[j] : -v[j];
          } else if (j === 'tradeDiscount') {
            return v['billType'] === 1 ? v[j] : -v[j];
          } else if (j === 'couponDiscountAmount') {
            return v['billType'] === 1 ? v[j] : -v[j];
          } else if (j === 'pointDiscountAmount') {
            return v['billType'] === 1 ? v[j] : -v[j];
          } else if (j === 'discountCapitalCat2Amount') {
            return v['billType'] === 1 ? v['billDiscountCapital']['capital2Amount'] : -v['billDiscountCapital']['capital2Amount'];
          } else if (j === 'sellerDiscountAmount') {
            return v['billType'] === 1 ? v[j] : -v[j];
          } else if (j === 'uuid') {
            if (v['uid'] > 100000) {
              return v[j];
            } else if (v['user']['userType'] === 9999 || v['user']['userType'] === 9997) {
              return '收银台（' + v[j] + '）';
            } else if (v['user']['userType'] === 9996) {
              return '便利店（' + v[j] + '）';
            } else if (v['user']['userType'] === 9998 || v['user']['userType'] === 888) {
              return '管理后台（' + v[j] + '）';
            }

            return '员工账号（' + v[j] + '）';
          } else {
            return v[j];
          }
        });
      });
    }
  }
};